module.exports = __webpack_public_path__ + "static/5-14bc39c3357033bfea93122b1d8c2357.jpg";